// import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import moment from 'moment';
// import VerifiedBadge from 'components/common/VerifiedBadge';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
// import { Link } from 'react-router-dom';

export const CertificationItem = ({
  details,
  isLast,
  index,
  certification,
  setCertification
}) => {
  const { provider, certificationType, expiration } = details;

  const handleRemove = index => {
    const updatedWorkExperience = [...certification];
    updatedWorkExperience.splice(index, 1);
    setCertification(updatedWorkExperience);
  };

  return (
    <Flex>
      <div className="flex-1 position-relative ps-3">
        <h6 className="fs-9 mb-0">{provider}</h6>
        <p className="my-1">{certificationType}</p>
        <p className="text-1000 mb-0">
          {moment(expiration).format('MM-DD-YYYY')}
        </p>
        {certification && (
          <Button
            size="sm"
            variant={'danger'}
            className="mt-2"
            onClick={() => handleRemove(index)}
          >
            Remove
          </Button>
        )}
        {!isLast && <div className="border-dashed border-bottom my-3"></div>}
      </div>
    </Flex>
  );
};

CertificationItem.propTypes = {
  details: PropTypes.any,
  index: PropTypes.any,
  certification: PropTypes.any,
  setCertification: PropTypes.func.isRequired,
  isLast: PropTypes.bool
};

export default CertificationItem;
